import React, { useEffect } from 'react'
import { Box, Typography, Grid } from '@mui/material'
import { useAuditLog } from './@hooks'
import { clearAuditLogSignals } from './@signals'
import AuditLogFilters from './Filters'
import AuditLogTable from './Table'
import EditMappingDrawer from './EditMappingDrawer'
import ImageComparisonModal from './EditMappingDrawer/ImageComparisonModal'
import UserAnalysisDrawer from './UserAnalysis'

export default function AuditLogPage() {
    useAuditLog()

    useEffect(() => {
        return clearAuditLogSignals
    }, [])

    return (
        <Box sx={{ p: 3 }}>
            <Box sx={{ mb: 3 }}>
                <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
                    Audit Log
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    Review mapping changes and user activity
                </Typography>
            </Box>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <AuditLogFilters />
                </Grid>
                <Grid item xs={12}>
                    <AuditLogTable />
                </Grid>
            </Grid>
            <EditMappingDrawer />
            <ImageComparisonModal />
            <UserAnalysisDrawer />
        </Box>
    )
}
